import { Colors } from '@/components/ui/types';
import { Nullable } from '@/models/Model';

import toPercent from '@/utils/statistics/toPercent';

export const GRADE_WARNING_THRESHOLD = 50;
export const GRADE_SUCCESS_THRESHOLD = 70;

export const gradeColor = (
  grade: Nullable<number>,
  maxGrade: Nullable<number>,
): Colors => {
  if (grade == null || !maxGrade) return 'default';

  const percent = toPercent(grade, maxGrade);

  if (percent <= GRADE_WARNING_THRESHOLD) return 'error';
  if (percent < GRADE_SUCCESS_THRESHOLD) return 'warning';
  return 'success';
};
